/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Swift_Mammoth_RelishInputs */

const en_safe_swift_mammoth_relish = /** @type {(inputs: Safe_Swift_Mammoth_RelishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Safe_Swift_Mammoth_RelishInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const safe_swift_mammoth_relish = /** @type {((inputs?: Safe_Swift_Mammoth_RelishInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Swift_Mammoth_RelishInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_safe_swift_mammoth_relish(inputs)
});